import { Button, Divider, Tree } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMetadataContext } from '../MetadataContext';
import ModalAddGroup from './ModalAddGroup';
import styled from 'styled-components';

const { DirectoryTree } = Tree;

const DirectoryTreeCustom = styled.div`
    .custom-title {
        display: inline-block;
        max-width: 220px;
    }
    .ant-tree.ant-tree-directory .ant-tree-treenode {
        padding: 10px 0px;
    }
    .ant-tree.ant-tree-directory .ant-tree-treenode:hover:before {
        background: #f8f4ff;
        border-radius: 6px;
    }
    ,
    .ant-tree.ant-tree-directory .ant-tree-treenode-selected:hover:before {
        background: #f8f4ff;
        border-radius: 6px;
    }
    ,
    .ant-tree.ant-tree-directory .ant-tree-treenode-selected:before {
        background: #f8f4ff;
        border-radius: 8px;
    }
    .ant-tree.ant-tree-directory
        .ant-tree-treenode-selected
        .ant-tree-switcher {
        color: #7b67fb;
        font-weight: 600;
    }
    .ant-tree.ant-tree-directory
        .ant-tree-treenode
        .ant-tree-node-content-wrapper.ant-tree-node-selected {
        color: #7b67fb;
        font-weight: 600;
        // border-left:4px solid #7b67fb;
    }
`;

export default function MetadataList({ metadataList }) {
    const UIContext = useMetadataContext();
    const UIProps = useMemo(() => {
        return {
            current: UIContext?.current,
            setCurrent: UIContext?.setCurrent,
            setIsSubMain: UIContext.setIsSubMain,
            isSubMain: UIContext.isSubMain,
            selectData: UIContext?.selectData,
            setSelectData: UIContext?.setSelectData,
        };
    }, [UIContext]);
    const { setCurrent, setIsSubMain, setSelectData } = UIProps;
    const { t } = useTranslation('metadata');
    const [openAddGroup, setOpenAddGroup] = useState(false);

    const onSelect = (keys, info) => {
        // console.log('Trigger Select', keys, info);
        const isLeaf = info?.selectedNodes[0]?.isLeaf;
        setCurrent(keys[0]);
        setIsSubMain(isLeaf);
        setSelectData(info?.selectedNodes[0]);
        console.log(keys[0], isLeaf);
    };
    const onExpand = (keys, info) => {
        console.log('Trigger Expand', keys, info);
    };

    useEffect(() => {}, []);

    return (
        <>
            <div className="p-8 bg-white rounded-md">
                <div className="flex justify-between items-center">
                    <div className="text-[#121330] font-semibold text-xl">
                        {t('Metadata List')}
                    </div>
                    <Button
                        size="large"
                        type="primary"
                        onClick={() => setOpenAddGroup(true)}
                    >
                        + {t('Add Group')}
                    </Button>
                </div>
                <Divider className="my-4" />
                <DirectoryTreeCustom>
                    <DirectoryTree
                        // showLine
                        // showIcon
                        // defaultExpandAll
                        onSelect={onSelect}
                        onExpand={onExpand}
                        treeData={metadataList}
                    />
                </DirectoryTreeCustom>
            </div>
            <ModalAddGroup
                open={openAddGroup}
                handelClose={() => setOpenAddGroup(false)}
            />
        </>
    );
}
